
<section class="main">

    <div class="">

        <div class="static p-md-3 p-1" [innerHTML]="getSafeHtml(htmlContent)" ></div>

    </div>

</section>


<app-footer></app-footer>
